import React, { useState, useEffect } from "react";
import { Select, Spin, Empty, Checkbox } from "antd";

/**
 * A component for selecting filter values with dynamic filtering
 * When a value is selected, it updates the available options in other filters
 */
const DynamicFilterSelector = ({
  label,
  options = [],
  value = [],
  onChange,
  loading = false
}) => {
  const [localOptions, setLocalOptions] = useState([]);

  // Update local options when props change
  useEffect(() => {
    // Convert options to format expected by Select
    const formattedOptions = options.map(option => ({
      value: option.value,
      label: option.label
    }));
    setLocalOptions(formattedOptions);
  }, [options]);

  // Handle value change
  const handleChange = (selectedValues) => {
    console.log(`${label} selected values:`, selectedValues);
    
    // Call onChange to update the parent component
    if (onChange) {
      onChange(selectedValues);
    }
  };

  // Format values for display
  const displayValues = Array.isArray(value) ? value : [];
  
  return (
    <div className="mb-3">
      <span>{label}</span> <br />
      <Spin spinning={loading}>
        <Select
          mode="multiple"
          allowClear
          style={{ width: '100%' }}
          placeholder="Select items"
          value={displayValues}
          onChange={handleChange}
          options={localOptions}
          optionFilterProp="label"
          showSearch
          maxTagCount={5}
          maxTagTextLength={20}
          listHeight={300}
          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
          notFoundContent={
            <Empty 
              image={Empty.PRESENTED_IMAGE_SIMPLE} 
              description="No options available" 
              style={{ margin: '8px 0' }} 
            />
          }
          optionRender={(option) => (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox checked={displayValues.includes(option.value)} />
              <span style={{ marginLeft: 8 }}>{option.label}</span>
            </div>
          )}
        />
      </Spin>
    </div>
  );
};

export default DynamicFilterSelector;
